function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.1 0C23.3 0 30 6.7 30 15.1 30 23.3 23.3 30 15.1 30 6.7 30 0 23.3 0 15.1 0 6.7 6.7 0 15.1 0zm-4.9 8l6.1 3.6 6.1 3.5-6.1 3.5-6.1 3.4V8z",
  fillRule: "evenodd",
  clipRule: "evenodd"
});

var SvgPlay = function SvgPlay(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyBpZD0icGxheSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzAgMzAiPgogIDxwYXRoIGQ9Ik0xNS4xIDBDMjMuMyAwIDMwIDYuNyAzMCAxNS4xIDMwIDIzLjMgMjMuMyAzMCAxNS4xIDMwIDYuNyAzMCAwIDIzLjMgMCAxNS4xIDAgNi43IDYuNyAwIDE1LjEgMHptLTQuOSA4bDYuMSAzLjYgNi4xIDMuNS02LjEgMy41LTYuMSAzLjR2LTYuOVY4eiIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+";
export { SvgPlay as ReactComponent };